<script>
export default {
  name: 'RightsSuccess',
  data() {
    return {
      // 权益配置信息
      rightsConfig: {
        'DJX0000001': {
          rightsName: '大鲸洗权益包',
          icon: '',
          steps: [
            '请在微信小程序"大鲸洗"中登录账户',
            '选择"我的"页面',
            '点击"红包"进入查看您的购买记录'
          ],
          // miniProgramLink: 'weixin://dl/business/?appid=wx3fa1d329df285310&path=pages/index/index',
          shortLink: '', // 短链接（可选）
          buttonShow: true
        },
        '455': {
          rightsName: '易企住 - 云宿易住酒店基础权益',
          icon: '',
          steps: [
            '请在微信小程序"易企住"中登录账户',
            '选择"会员中心"页面',
            '点击"我的优惠券"进入查看您的购买记录'
          ],
          // miniProgramLink: 'weixin://dl/business/?appid=wxb942273606ca92f8&path=sub-packages/moveFile-package/pages/coupon-list/index', // 小程序 scheme 链接
          shortLink: '', // 短链接（可选）
          buttonShow: true
        },
        '379': {
          rightsName: '易企住 - 云宿易住酒店权益',
          icon: '',
          steps: [
            '请在微信小程序"易企住"中登录账户',
            '选择"会员中心"页面',
            '点击"我的优惠券"进入查看您的购买记录'
          ],
          // miniProgramLink: 'weixin://dl/business/?appid=wxb942273606ca92f8&path=sub-packages/moveFile-package/pages/coupon-list/index', // 小程序 scheme 链接
          shortLink: '', // 短链接（可选）
          buttonShow: true
        },
        'default': {
          rightsName: '权益',
          icon: '',
          steps: [
            '您的权益已到账',
            '请在相关平台登录查看'
          ],
          miniProgramLink: '',
          shortLink: '',
          buttonShow: false
        }
      },
      rightsInfo: {},
      show: false
    }
  },
  mounted() {
    const goodsId = this.$route.query.goodsId
    if (goodsId && this.rightsConfig[goodsId]) {
      this.rightsInfo = this.rightsConfig[goodsId]
    } else {
      this.rightsInfo = this.rightsConfig['default']
    }
    setTimeout(() => {
      this.show = true
    }, 100)
  },
  methods: {
    // // 判断是否在微信环境
    // isWeChat() {
    //   return /micromessenger/i.test(navigator.userAgent)
    // },
    //
    // // 跳转小程序
    // jumpToMiniProgram() {
    //   const { miniProgramLink, shortLink } = this.rightsInfo
    //
    //   // 如果有短链接，在微信环境内通过 a 标签跳转
    //   if (shortLink && this.isWeChat()) {
    //     // 创建隐藏的 a 标签触发跳转（用户主动点击的模拟）
    //     const link = document.createElement('a')
    //     link.href = shortLink
    //     link.click()
    //    return
    //   }
    //
    //   // 在微信环境内，使用 scheme 跳转小程序
    //   if (this.isWeChat() && miniProgramLink) {
    //     window.location.href = miniProgramLink
    //   } else if (miniProgramLink) {
    //     // 非微信环境，提示用户打开微信
    //     this.$toast({
    //       message: '请在微信客户端打开链接',
    //       position: 'bottom',
    //       duration: 2000
    //     })
    //   }
    // }
  }
}
</script>

<template>
  <div class="rights-success">
    <div class="success-content" :class="{ 'show': show }">
      <!-- 成功图标 -->
      <div class="success-icon">
        <svg width="120" height="120" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="58"fill="#E8F5E9" stroke="#4CAF50" stroke-width="4"/>
          <path d="M35 60 L55 80 L85 40"fill="none" stroke="#4CAF50" stroke-width="6" 
                stroke-linecap="round" stroke-linejoin="round"
                class="check-animation"/>
        </svg>
      </div>

      <!-- 权益名称 -->
      <h2 class="rights-title">恭喜您！</h2>
      <p class="rights-subtitle">{{ rightsInfo.rightsName }}已到账</p>

      <!-- 分割线 -->
      <div class="divider"></div>

      <!-- 行权指引 -->
      <div class="guide-section">
        <h3 class="guide-title">使用指引</h3>
        <div class="steps-container">
          <div class="step-item" v-for="(step, index) in rightsInfo.steps" :key="index">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-text">{{ step }}</div>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
<!--      <div class="action-buttons">-->
<!--        <button -->
<!--          v-if="rightsInfo.buttonShow && (rightsInfo.miniProgramLink || rightsInfo.shortLink)" -->
<!--          class="btn-primary"-->
<!--          @click="jumpToMiniProgram"-->
<!--        >-->
<!--          前往小程序使用-->
<!--        </button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
.rights-success {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 30px;
}

.success-content {
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  border-radius: 24px;
  padding: 80px 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.5s ease;
  
  &.show {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon {
  text-align: center;
  margin-bottom: 40px;
  
  .check-animation {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: drawCheck 0.6s ease forwards 0.3s;
  }
}

@keyframes drawCheck {
  to {
    stroke-dashoffset: 0;
  }
}

.rights-title {
  font-size: 44px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  margin: 0 0 12px 0;
  font-family: PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
}

.rights-subtitle {
  font-size: 28px;
  color: #666666;
  text-align: center;
  margin: 0 0 50px 0;
  font-family: PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
}

.divider {
  height: 1px;
  background: linear-gradient(to right, transparent, #e0e0e0, transparent);
  margin: 40px 0;
}

.guide-section {
  margin-bottom: 50px;
  
  .guide-title {
    font-size: 32px;
    font-weight: 600;
    color: #333333;
    margin: 0 0 30px 0;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
  }
}

.steps-container {
  .step-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;
    padding: 24px;
   background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &:hover {
     background: #f0f2f5;
      transform: translateX(4px);
    }
  }
  
  .step-number {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    font-size: 24px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  }
  
  .step-text {
    flex: 1;
    font-size: 26px;
    line-height: 1.6;
    color: #333333;
    padding-top: 4px;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
  }
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  button {
    width: 100%;
    height: 88px;
    border-radius: 44px;
    font-size: 32px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
    
    &:active {
      transform: scale(0.98);
    }
  }
  
  .btn-primary {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
    
    &:hover {
      box-shadow: 0 12px 28px rgba(102, 126, 234, 0.5);
      transform: translateY(-2px);
    }
  }
  
  .btn-secondary {
   background: #ffffff;
    color: #667eea;
    border: 2px solid #667eea;
    
    &:hover {
     background: #f5f7ff;
    }
  }
}

// 移动端适配
@media screen and (max-width: 750px) {
  .rights-success {
    padding: 20px 20px;
  }
  
  .success-content {
    padding: 40px 24px;
  }
  
  .rights-title {
    font-size: 36px;
  }
  
  .rights-subtitle {
    font-size: 24px;
  }
  
  .guide-title {
    font-size: 28px !important;
  }
  
  .step-text {
    font-size: 24px !important;
  }
  
  .action-buttons button {
    height: 80px;
    font-size: 28px !important;
  }
}
</style>